import { render } from "./items-nav.vue?vue&type=template&id=dfd7a7b6&ts=true"
import script from "./items-nav.vue?vue&type=script&lang=ts"
export * from "./items-nav.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__